import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";

export const BreadcrumbBox: any = styled(Box)`
    width: 100%;
    display: flex;
    height: 54px;
    align-items: center;
    justify-content: center;
    border-bottom-color: rgb(189, 190, 193);
    border-bottom-style: solid;
    border-bottom-width: 1px;

    .breadcrumb-wrapper {
        padding: 0 15px;
        width: 100%;
        max-width: 1140px;
        display: flex;
        flex: 1 0 1;
        flex-direction: row;
        justify-content: space-between;
        vertical-align: middle;

        .contact {
            display: flex;
            flex-direction: row;
        }
    }
`;

export const BreadcrumbEmptyBox: any = styled(Box)`
    width: 100%;
    height: 54px;
`;
